module.exports = __webpack_public_path__ + "img/pill.a4d14a92.svg";